import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, SERVICES } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1C2A39] text-white relative overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <span className="font-display font-extrabold text-4xl tracking-tight">Brite<span className="text-[#5EEAD4]">lines</span></span>
            <p className="mt-5 text-slate-300 max-w-sm leading-relaxed">
              Adelaide's trusted cleaning team. Bright homes, spotless offices and stress-free bond cleans — done properly, every time.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <span className="text-xs px-3 py-1.5 rounded-full bg-white/10 text-slate-200">100% Satisfaction</span>
              <span className="text-xs px-3 py-1.5 rounded-full bg-white/10 text-slate-200">Police-Checked</span>
              <span className="text-xs px-3 py-1.5 rounded-full bg-white/10 text-slate-200">Eco-Friendly</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="kicker !text-[#5EEAD4] mb-5">Services</h4>
            <ul className="space-y-3">
              {SERVICES.slice(0, 5).map((s) => (
                <li key={s.key}><Link to="/services" className="text-slate-300 hover:text-white transition-colors duration-300 text-sm">{s.title}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="kicker !text-[#5EEAD4] mb-5">Get in touch</h4>
            <ul className="space-y-4">
              <li><a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors duration-300 text-sm"><Phone size={16} className="text-[#5EEAD4]" /> {CONTACT.phone}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors duration-300 text-sm"><Mail size={16} className="text-[#5EEAD4]" /> {CONTACT.email}</a></li>
              <li className="flex items-start gap-3 text-slate-300 text-sm"><MapPin size={16} className="text-[#5EEAD4] mt-0.5" /> {CONTACT.address}</li>
            </ul>
            <Link to="/quote" className="btn-primary !bg-white !text-[#1C2A39] mt-7 hover:!bg-[#5EEAD4]">Get a Free Quote</Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} Britelines Cleaning · Adelaide, South Australia</p>
          <p>Cleaning services across Adelaide & surrounding suburbs.</p>
        </div>
      </div>
    </footer>
  );
}
